/**
 * Usando um valor inicial, encadeia uma função e retorna seu resultado.
 * @param {A} initial
 * @param {function(A):function} callback
 * @param {Array.<*>} params
 * @returns {B}
 * @template A, B
 */
export const chain = (initial, callback, params) => {
  const value = params.reduce((value, args) => {
    return callback(value).apply(value, [...args])
  }, initial)

  return value
}

/**
 * Faz em forma de corrente o replace do texto usando os argumentos especificados.
 * @param {String} text
 * @param {Array.<*>} args
 * @returns {String}
 */
export const replace = (text, args) => chain(text, text => text.replace, args)



// WEBPACK FOOTER //
// ./src/helpers/replace.js